import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { dcrunlockdataModel } from '../../model'
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
@Component({
  selector: 'app-dcrunlockhistory',
  template: require('./dcrunlockhistory.component.html'),
  styles: []
})
export class DcrUnlockHistoryComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  firstDate: string;
  lastDate: string;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;
  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  ManagerList: any;
  DCRData: any = [];
  stateList: any = [];
  token:any;
  dcrunlockhistory_Form = new FormGroup({
    fromDate: new FormControl('', [Validators.required]),
    toDate: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),

  });
  f_ChkNum(p_value) {
    var Num = Number(p_value);
    if (Num) {
      return Num;
    }
    return 0;
  }
  dcrunlockdataModel: dcrunlockdataModel = new dcrunlockdataModel();
  static parameters = [ApiService, Router, HttpClient]
  constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      {
        headerName: 'Employee Name', field: "Client_Name", filter: 'agTextColumnFilter'
      },
      {
      headerName: 'Manager', field: "Manager", filter: 'agTextColumnFilter'
    },
      { headerName: 'Designation', field: "Designation", filter: 'agTextColumnFilter' },
      { headerName: 'Head Qtr', field: "HQName", filter: 'agTextColumnFilter' },
      { headerName: 'Day Plan Time', field: "PlanTime", filter: 'agTextColumnFilter' },
      { headerName: 'DCR Date', field: "PlanDate", filter: 'agTextColumnFilter' },
      { headerName: 'Approved By', field: "ApprovedBy", filter: 'agTextColumnFilter' ,width :350 },
      { headerName: 'Approved Date', field: "ApprovedDate", filter: 'agTextColumnFilter' },


    ];
    this.defaultColDefine = { resizable: true };
    // this.rowData = [
    //   { sno: '1', emp: 'Satya Prakash', emp_code: "E0073", staff_type: "SO", desig: "SO", division: "Surgical Group", head_qtr: "Muradabad", day_plan: "9:12", submit_statu: "Yes", submit_by: "Admin-02/03/2021 9:12", date: "01/03/2021", remarks: "" }
    // ];
    this.rowHeight = 50;
  }


  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
    this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
    console.log('firstDate ', this.firstDate, this.lastDate);
    this.dcrunlockhistory_Form.controls['fromDate'].setValue(
      this.firstDate
    );
    this.dcrunlockhistory_Form.controls['toDate'].setValue(
      this.lastDate
    );
    
    $('#filter-option').trigger('click');
    this.getManagerDetails();
    this.getState();
    this.dcrunlockdataModel.ManagerID = '0';
    this.dcrunlockdataModel.stateId = 0;
    this.dcrunlockdataModel.empId;
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
  }


  onBtnExport() {
    this.api.exportDataAsExcel({ fileName: 'DCR_Unlock_History' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }


  getManagerDetails() {
    var data = {
        Id: this.token.id
    };
    this.http.post('/api/Report/getManagerListForLogUnLog',data)
        .subscribe(res => {
            this.ManagerList = res;
        });
}


  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }


  eventHandlerDcrUnlock() {
    //this.api.showLoadingOverlay();
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dcrunlockdataModel.fromDate = this.dcrunlockhistory_Form.value.fromDate;
    this.dcrunlockdataModel.toDate = this.dcrunlockhistory_Form.value.toDate;
    this.dcrunlockdataModel.empId = token.id;
    var parent = this;
   this.busy = this.apiService.DCRUnlockHistory(this.dcrunlockdataModel).subscribe((res: any) => {
      this.DCRData = res.data;
    })
  }
}
